import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useClient } from '../contexts/ClientContext';

interface LoginRedirectProps {
  children: React.ReactNode;
}

const LoginRedirect: React.FC<LoginRedirectProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const { selectedClient, hasFetched } = useClient();

  // Show nothing while auth is loading
  if (loading) {
    return null;
  }

  // If user is not authenticated, show the login form immediately
  if (!user) {
    return <>{children}</>;
  }

  // For authenticated users, we need to wait for client context to be ready
  // to determine the correct redirect path
  if (!hasFetched) {
    return null;
  }

  // If user is authenticated, redirect based on role and tenant selection
  if (user.role === 'support_manager' && !selectedClient) {
    // Support managers without selected tenant go to tenant selection
    return <Navigate to="/tenant-selection" replace />;
  } else {
    // All other authenticated users go to dashboard
    return <Navigate to="/" replace />;
  }
};

export default LoginRedirect;
